
import respUtility from '~/mixins/respUtility';

export default {
  name: 'ListingFooterSeoText',
  mixins: [respUtility],
  props: {
    content: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
